// extracted by mini-css-extract-plugin
export var errorBanner = "_k0-2";
export var scroller = "_k0-0";
export var thinking = "_k0-1";
export var visuallyHidden = "_k0-3";